<template>
  <b-overlay :show="page_loader">
    <div class=" employee-tab leave-attendance-dashboard">

      <div class="col-md-10 col-sm-12 pl-0" >
        <h4 class="atlhr-dashboard-title mt-10">Leave & Attendance<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Leave & Attendance / Overtime Runs</span></h4>
      </div>

<div class="ibox col-md-12 py-3 mt-4">
    <div class="ibox col-md-12 border no-shadow radius-8 employee-table-wrapper">
      <div class="row mt-4">
        <div class="col-6 d-flex align-items-center">
          <div class="ibox-title dashboard_title px-0">
            <h4 class="clearfix">
              <span class="float-left">Draft Overtime Runs</span> 
              <span class="float-right"></span>
            </h4>
          </div>
        </div>
        <div class="col-6 text-right">
          <a class="btn btn-primary mb-2 text-light" @click.prevent="initiateRun" href="#">
            <i class="fa fa-certificate" aria-hidden="true"></i> Initiate Overtime Run
          </a>
        </div>

      </div>

      <table class="dataTable table">
        <thead>
        <tr class="table-head table-head-center">
          <template v-for="column in columns">
            <th v-if="column.sort" @click="sortBy(column.name)"
                :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                class="cursor-pointer"><span>{{ column.label }}</span></th>
            <th v-else><span>{{ column.label }}</span></th>
          </template>
        </tr>
        </thead>
        <tbody>
        <tr class="table-row hover-bg" v-for="(run, idx) in paginatedData" :key="'draft-' + idx">
          <td class="text-left">
            <a class="cursor-pointer" :href="$api_url + '/leave-attendance/overtime-runs/' + run.id">{{ run.month_label }} {{ run.year }}</a>
          </td>
          <td class="text-center">{{ run.total_employees }}</td>
          <td class="text-center">{{ run.total_salary_days }}</td>
          <td class="text-right">
            <div class="action">
              <b-button-toolbar class="float-right position-relative">
                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                <div class="dropdown-menu action-dropdown-menu px-0" aria-labelledby="actionDropdown">
                  <b-button-group class="">
                    <b-button class="border-0 rounded"  title="Preview" @click="openEditPage(run.id)">
                      <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Preview
                    </b-button>
                    <b-button class="border-0 rounded" title="Delete Run" @click="confirmDelete(run.id)">
                      <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                    </b-button>
                  </b-button-group>
                </div>
              </b-button-toolbar>
            </div>
          </td>
        </tr>

        <tr v-if="paginatedData.length == 0">
          <td colspan="5" class="text-center list-no-data">{{ blankmsg }}</td>
        </tr>
        </tbody>
      </table>

      <div class="ibox-title dashboard_title px-0">
        <h4 class="clearfix">
          <span class="float-left">Approved Overtime Runs</span> 
          <span class="float-right"></span>
        </h4>
      </div>


      <table class="dataTable table">
        <thead>
        <tr class="table-head table-head-center">
          <template v-for="column in columns_two">
            <th v-if="column.sort" @click="sortBy(column.name)"
                :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                class="cursor-pointer"><span>{{ column.label }}</span></th>
            <th v-else><span>{{ column.label }}</span></th>
          </template>
        </tr>
        </thead>
        <tbody>
        <tr class="table-row hover-bg" v-for="(run, idx) in paginatedData_two" :key="'approved-' + idx">
          <td class="text-left">
            <a class="cursor-pointer" :href="$api_url + '/leave-attendance/overtime-runs/' + run.id">{{ run.month_label }} {{ run.year }}</a>
          </td>
          <td class="text-center">{{ run.total_employees }}</td>
          <td class="text-center">{{ run.total_salary_days }}</td>
          <td class="text-right">
            <div class="action">
              <b-button-toolbar class="float-right position-relative">
                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                  <b-button-group class="">
                    <b-button class="border-0 rounded" variant="outline-secondary"  title="Preview" @click="openEditPage(run.id)">
                      <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Preview
                    </b-button>
                    <b-button class="border-0 rounded" variant="outline-secondary" title="Unapprove" @click="confirmUnapproveRun(run.id)">
                      <b-icon icon="skip-backward" aria-hidden="true"></b-icon> Unapprove
                    </b-button>
                  </b-button-group>
                </div>
              </b-button-toolbar>
            </div>
          </td>
        </tr>
        <tr v-if="paginatedData_two.length == 0">
          <td colspan="5" class="text-center list-no-data">{{ blankmsg_two }}</td>
        </tr>
        </tbody>
      </table>

      <div v-if="approved_runs.length > 0" class="px-3 mt-4">
        <ul class="pagination b-pagination float-left mb-0 mt-1">
          <li class="page-item disabled m-2">View</li>
          <li class="page-item disabled">
            <b-form-select v-model="temp_length_two" :options="length_options_two" @change="setFirstPage_two()"></b-form-select>
          </li>
          <li class="page-item disabled m-2">per page. Total {{approved_runs.length}} records found.</li>
        </ul>
        <b-pagination-nav v-model="this_pagination_two.currentPage"
                          :number-of-pages="this_pagination_two.pages"
                          base-url="#" prev-text="Previous" next-text="Next"
                          first-number last-number>
        </b-pagination-nav>
      </div>

    </div>
  </div>

      <b-modal id="overtime-delete-password-modal" title="Confirm Password" centered hide-footer>
        <p class="mb-2">Enter your password to delete this overtime run.</p>
        <b-form-input type="password" v-model="password" placeholder="Password" autocomplete="current-password"></b-form-input>
        <b-button class="w-100 my-2" @click="deleteRun(run_id)">Delete</b-button>
        <b-button class="w-100" @click="$bvModal.hide('overtime-delete-password-modal')">Cancel</b-button>
      </b-modal>
      <b-modal id="overtime-unapprove-password-modal" title="Confirm Password" centered hide-footer>
        <p class="mb-2">Enter your password to unapprove this overtime run. It will move back to draft.</p>
        <b-form-input type="password" v-model="password" placeholder="Password" autocomplete="current-password"></b-form-input>
        <div v-if="unapprove_error" class="text-danger small mt-2">{{ unapprove_error }}</div>
        <b-button class="w-100 my-2" :disabled="loading" @click="unapproveRun(run_id)">Unapprove</b-button>
        <b-button class="w-100" @click="$bvModal.hide('overtime-unapprove-password-modal')">Cancel</b-button>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import moment from 'moment';
export default {
  mounted() {
    this.fetchOvertimeRuns();
  },
  data() {
    /* draft columns */
    let sortOrders = {};
    let columns = [
      { label: 'Month', name: 'month' , sort: false},
      { label: 'Employee Count', name: 'total_employees', type: 'number'  , sort: true},
      { label: 'Total Salary Benefit Days', name: 'total_salary_days', type: 'number' , sort: true },
      { label: 'Actions', sort: false },
    ];
    columns.forEach((column) => { sortOrders[column.name] = -1; });

    /* approved columns */
    let sortOrders_two = {};
    let columns_two = [
      { label: 'Month', name: 'month' , sort: false },
      { label: 'Employee Count', name: 'total_employees', type: 'number' , sort: true },
      { label: 'Total Salary Benefit Days', name: 'total_salary_days', type: 'number'  , sort: true},
      { label: 'Actions', sort: false },
    ];
    columns_two.forEach((column) => { sortOrders_two[column.name] = -1; });

    return {
      success: '',
      run_id: 0,
      password: '',
      error_msg: '',
      loading: false,
      page_loader: true,
      unapprove_error: '',

      /* draft runs */
      draft_runs: [],
      blankmsg: 'Fetching data..',
      columns: columns,
      sortKey: '',
      sortOrders: sortOrders,
      length: 20,
      temp_length: 20,
      this_pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

      /* approved runs */
      approved_runs: [],
      blankmsg_two: 'Fetching data..',
      columns_two: columns_two,
      sortKey_two: '',
      sortOrders_two: sortOrders_two,
      length_two: 20,
      temp_length_two: 20,
      length_options_two: [
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 500, text: "500" },
        { value: 1500, text: "1500" },
      ],
      this_pagination_two: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
    }
  },
  methods: {

confirmUnapproveRun(id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to unapprove this overtime run?', {
        title: 'Confirm Unapprove',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.run_id = id;
        this.password = '';
        this.unapprove_error = '';
        this.$bvModal.show('overtime-unapprove-password-modal');
      });
    },

    unapproveRun(id) {
      if (!this.password) {
        this.unapprove_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.unapprove_error = '';

      let formData = new FormData();
      formData.append('password', btoa(this.password));
      axios.post(this.$api_url + '/leave-attendance/overtime-runs/' + id + '/revert', formData)
        .then((response) => {
          this.$bvToast.toast(response.data.message || 'Overtime run moved back to draft.', {
            solid: true,
            variant: 'success',
            title: 'Success'
          });
          this.password = '';
          this.$bvModal.hide('overtime-unapprove-password-modal');
          this.fetchOvertimeRuns();
        })
        .catch((error) => {
          this.unapprove_error = (error.response && error.response.data && error.response.data.message)
            || 'Failed to unapprove overtime run.';
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initiateRun() {
      axios.post(this.$api_url + '/leave-attendance/overtime-runs/draft/check').then(res => {
        if(res.data == true) {
          this.$bvToast.toast('Approve previous draft run first', {
            variant: 'danger',
            title: 'Error',
            solid: true,
          })
        } else {
          window.location.href = this.$api_url + '/leave-attendance/overtime-run';
        }
      })
    },
    openEditPage(id)
    {
      window.location.href = this.$api_url + '/leave-attendance/overtime-runs/' + id;
    },

    confirmDelete(id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete?', {
        title: 'Confirm Deletion',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.run_id = id;
        this.$bvModal.show('overtime-delete-password-modal');
      });
    },

    deleteRun(id)
    {
      this.loading = true;
      this.success = '';
      this.error_msg = '';
      let formData = new FormData();
      formData.append('password', btoa(this.password));

      axios.post(this.$api_url + '/leave-attendance/overtime-runs/delete/' + id, formData)
        .then(function(response)
        {
          this.$bvToast.toast('Overtime run deleted successfully.',{
            solid: true,
            variant: 'success',
            title: 'Success'
          });
          this.$bvModal.hide('overtime-delete-password-modal');
          this.fetchOvertimeRuns();
        }.bind(this))
        .catch((error) =>
        {
          this.serverError(error);
        })
        .finally(function()
        {
          this.loading = false;
        }.bind(this));
    },
    formatMe(d) {
      return moment(d).format('YYYY/MM/DD');
    },

    formatTime(d) {
      return moment(d).format('hh:mm:ss A');
    },

    getIndex(array, key, value) {
      return array.findIndex(i => i[key] == value);
    },

    /* draft sorting */
    sortBy(key) {
      this.resetPagination();
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },

    /* approved sorting */
    sortBy_two(key) {
      this.resetPagination_two();
      this.sortKey_two = key;
      this.sortOrders_two[key] = this.sortOrders_two[key] * -1;
    },

    /* draft pagination */
    paginate(array, length, pageNumber) {
      let l = parseInt(array.length);
      let m = parseInt(length);
      this.this_pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
      this.this_pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
      this.this_pagination.prevPage = pageNumber > 1 ? pageNumber : '';
      this.this_pagination.nextPage = array.length > this.this_pagination.to ? pageNumber + 1 : '';
      if (l > 0) {
        this.this_pagination.pages = Math.ceil(l / m);
      }
      return array.slice((pageNumber - 1) * length, pageNumber * length);
    },
    resetPagination() {
      this.this_pagination.currentPage = 1;
      this.this_pagination.prevPage = '';
      this.this_pagination.nextPage = '';
    },
    setFirstPage() {
      this.this_pagination.currentPage = 1;
      this.length = this.temp_length;
    },

    /* approved pagination */
    paginate_two(array, length, pageNumber) {
      let l = parseInt(array.length);
      let m = parseInt(length);
      this.this_pagination_two.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
      this.this_pagination_two.to = pageNumber * length > array.length ? array.length : pageNumber * length;
      this.this_pagination_two.prevPage = pageNumber > 1 ? pageNumber : '';
      this.this_pagination_two.nextPage = array.length > this.this_pagination_two.to ? pageNumber + 1 : '';
      if (l > 0) {
        this.this_pagination_two.pages = Math.ceil(l / m);
      }
      return array.slice((pageNumber - 1) * length, pageNumber * length);
    },
    resetPagination_two() {
      this.this_pagination_two.currentPage = 1;
      this.this_pagination_two.prevPage = '';
      this.this_pagination_two.nextPage = '';
    },
    setFirstPage_two() {
      this.this_pagination_two.currentPage = 1;
      this.length_two = this.temp_length_two;
    },

    /* API calls */
    fetchOvertimeRuns() {
      this.page_loader = true;
      axios.get(this.$api_url + '/leave-attendance/overtime-runs/list').then(function (response) {
        this.draft_runs = response.data.draft || [];
        this.approved_runs = response.data.approved || [];
        this.page_loader = false;
      }.bind(this)).catch(function () {
        this.error_msg = 'Failed to load overtime runs.';
        this.page_loader = false;
      }.bind(this));
    },
  },
  computed: {
    filteredData() {
      let filtered_list = this.draft_runs;

      if (filtered_list.length == 0)
        this.blankmsg = "Nothing found.";

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index].type && this.columns[index].type == 'number') {
            return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
          }
          return (a == b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return filtered_list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.this_pagination.currentPage);
    },

    filteredData_two() {
      let filtered_list = this.approved_runs;

      if (filtered_list.length == 0)
        this.blankmsg_two = "Nothing found.";

      let sortKey = this.sortKey_two;
      let order = this.sortOrders_two[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns_two, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns_two[index].type && this.columns_two[index].type == 'number') {
            return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
          }
          return (a == b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return filtered_list;
    },
    paginatedData_two() {
      return this.paginate_two(this.filteredData_two, this.length_two, this.this_pagination_two.currentPage);
    },
  },
}
</script>
